// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

const BASE_URL = config.INTEGRATION_SUMMARY_ANALYTICS_URL;

const makeApiCall = (endpoint, query) => {
    query = { integrationId: query };
    return api.get(`${BASE_URL}${endpoint}`, query, {});
};

function getShipmentsCount(integrationId): any {
    const endpoint = '/shipments_count';
    return makeApiCall(endpoint, integrationId);
}

function getShipmentRatesCount(integrationId) {
    const endpoint = '/shipment_rates_count';
    return makeApiCall(endpoint, integrationId);
}

function getAdjustmentsCount(integrationId) {
    const endpoint = '/adjustments_count';
    return makeApiCall(endpoint, integrationId);
}

function getShipmentsWithRatesCount(integrationId) {
    const endpoint = '/shipments_with_rates_count';
    return makeApiCall(endpoint, integrationId);
}

function getShipmentsWithNoRatesCount(integrationId) {
    const endpoint = '/shipments_with_no_rates_count';
    return makeApiCall(endpoint, integrationId);
}

function getSurchargesCount(integrationId) {
    const endpoint = '/surcharges_count';
    return makeApiCall(endpoint, integrationId);
}

function getNonZeroSurchargesCount(integrationId) {
    const endpoint = '/non_zero_surcharges_count';
    return makeApiCall(endpoint, integrationId);
}

function getIntegrationSummary(integrationId) {
    const endpoint = '/integration_summary';
    return makeApiCall(endpoint, integrationId);
}

export {
    getShipmentsCount,
    getShipmentRatesCount,
    getAdjustmentsCount,
    getShipmentsWithRatesCount,
    getShipmentsWithNoRatesCount,
    getSurchargesCount,
    getNonZeroSurchargesCount,
    getIntegrationSummary,
};
